<template>
  <div class="box d-flex align-items-center">
    <div class="w-100">
      <!-- Header -->
      <div class="container text-center mb-4">
        <div class="row justify-content-center">
          <img
            src="https://vendino.ams3.cdn.digitaloceanspaces.com/production/images/brand/logo_light_x500.png"
            height="52"
            class="ml--3"
          />
        </div>
      </div>
      <!-- Page content -->
      <div class="container pb-5">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-7">
            <login-card></login-card>
            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="d-inline-block text-white">
                  {{ $t("dont-have-an-account") }}?
                </p>
                <nuxt-link
                  to="/auth/signup"
                  class="font-weight-bold text-white"
                >
                  {{ $t("sign-up-now") }}
                  <i class="fa fa-arrow-right text-sm"></i>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginCard from "@/components/auth/LoginCard.vue";
export default {
  name: "login-page",
  components: {
    LoginCard
  },
  layout: "ShopAuthLayout",
  head() {
    return {
      title: `${this.$t("sign-in")} | Vendino`
    };
  },
  methods: {
    handleLogout() {
      // Redirecting to current path to clear route query
      this.$router.push(this.$route.path);
      // Show confirmation notification
      this.$notify({
        title: this.$t("logged-out"),
        message: this.$t("logged-out-notice-description"),
        type: "success"
      });
    }
  },
  created() {
    if (this.$route.query.loggedOut == "true") {
      this.handleLogout();
    }
  }
};
</script>
